/* Custom Shoppable Videos v14.9.6 (Prestige-compatible)
   - Same as v14.9.5 + poster overlay logic
   - Poster fades out when media plays, reappears when paused/ended
   - NEW: Prestige mini-cart integration (cart:refresh + drawer open)
*/

(function () {
    'use strict';

    var YT_ORIGIN = 'https://www.youtube-nocookie.com'; // match your embed
    var VIMEO_ORIGIN = 'https://player.vimeo.com';

    if (!window.__csvGlobalDocListeners) {
        window.__csvGlobalDocListeners = { fullscreen: false };
    }

    if (window.__csvVideosInitOnce) return;
    window.__csvVideosInitOnce = true;

    // Map iframe.contentWindow => slide (for YouTube state events → toggle poster)
    window.__csvIframeWinToSlide = window.__csvIframeWinToSlide || new WeakMap();

    // ------------------------------- Helpers -------------------------------
    function csvFreezeTrackOnce(carousel, next) {
        // Adds a class that disables the container’s transform transition for one frame
        carousel.classList.add('csv-no-transition');
        requestAnimationFrame(function () {
            try { next && next(); } finally {
            // Remove on the very next frame so normal transitions resume
            requestAnimationFrame(function () {
                carousel.classList.remove('csv-no-transition');
            });
            }
        });
    }

    function onReady(cb) {
        if (document.readyState !== 'loading') cb();
        else document.addEventListener('DOMContentLoaded', cb, { once: true });
    }

    function getEmbla() {
        if (window.__emblaPromise) return window.__emblaPromise;
        if (window.EmblaCarousel) return Promise.resolve(window.EmblaCarousel);
        return (window.__emblaPromise = new Promise(function (resolve, reject) {
            var tries = 0, t = setInterval(function () {
                if (window.EmblaCarousel) { clearInterval(t); resolve(window.EmblaCarousel); }
                else if (++tries > 250) { clearInterval(t); reject(new Error('EmblaCarousel not found')); }
            }, 20);
        }));
    }

    // One-time preconnect to speed up first handshake to providers
    function preconnectOnce() {
        if (window.__csvPreconnectDone) return;
        window.__csvPreconnectDone = true;
        [
            ['https://www.youtube-nocookie.com', 'anonymous'],
            ['https://i.ytimg.com', 'anonymous'],
            ['https://player.vimeo.com', 'anonymous'],
            ['https://i.vimeocdn.com', 'anonymous']
        ].forEach(function (pair) {
            var l = document.createElement('link');
            l.rel = 'preconnect';
            l.href = pair[0];
            l.crossOrigin = pair[1];
            document.head.appendChild(l);
        });
    }

    function patchYouTubeIframes(carousel) {
        carousel.querySelectorAll('iframe[data-provider="youtube"]').forEach(function (iframe) {
            var src = iframe.getAttribute('src');
            if (src && src.indexOf('enablejsapi=1') === -1) {
                try {
                    var url = new URL(src, window.location.href);
                    url.searchParams.set('enablejsapi', '1');
                    url.searchParams.set('playsinline', '1');
                    url.searchParams.set('fs', '1');
                    iframe.setAttribute('src', url.toString());
                } catch (_) {}
            }
            var allow = (iframe.getAttribute('allow') || '');
            if (!/fullscreen/i.test(allow)) {
                iframe.setAttribute('allow', (allow ? allow + '; ' : '') + 'fullscreen');
            }
            if (!iframe.hasAttribute('allowfullscreen')) {
                iframe.setAttribute('allowfullscreen', '');
            }
        });
    }

    function sendYouTube(iframe, command, value) {
        if (!iframe || !iframe.contentWindow) return;
        try {
            iframe.contentWindow.postMessage(
                JSON.stringify({ event: 'command', func: command, args: value ? [value] : [] }),
                YT_ORIGIN
            );
        } catch (err) { console.warn('[YouTube] postMessage failed:', err); }
    }

    function setSoundButtonState(soundBtn, muted) {
        if (!soundBtn) return;
        soundBtn.setAttribute('aria-pressed', String(!muted));
        soundBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        soundBtn.classList.toggle('csv-muted', muted);
        var muteIcon = soundBtn.querySelector('.csv-mute-icon');
        var unmuteIcon = soundBtn.querySelector('.csv-unmute-icon');
        if (muteIcon && unmuteIcon) {
            muteIcon.style.display = muted ? 'inline-block' : 'none';
            unmuteIcon.style.display = muted ? 'none' : 'inline-block';
        }
    }

    // ---------- Prestige detection + drawer open ----------
    function isPrestige() {
        // Detect Maestrooo/Prestige cart drawer wiring
        return !!document.querySelector(
            '#cart-drawer, cart-drawer, [aria-controls="cart-drawer"]'
        );
    }

    async function openPrestigeMiniCart() {
        try {
            // Tell Prestige to refresh its cart state/counters
            document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
            );

            // Try direct drawer element first
            const drawerEl =
            document.getElementById('cart-drawer') ||
            document.querySelector('cart-drawer');

            // Many Maestrooo drawers expose show()/open()
            if (drawerEl && typeof drawerEl.show === 'function') {
            await drawerEl.show();
            return;
            }
            if (drawerEl && typeof drawerEl.open === 'function') {
            await drawerEl.open();
            return;
            }
            if (drawerEl && 'open' in drawerEl) {
            // Last-resort: boolean open attr
            drawerEl.setAttribute('open', '');
            drawerEl.classList.add('is-open');
            return;
            }

            // Fallback: click the header cart link that controls the drawer
            const opener = document.querySelector('[aria-controls="cart-drawer"]');
            if (opener) opener.click();
        } catch (e) {
            console.warn('[CSV] Could not open Prestige cart drawer:', e);
        }
    }

    // Dawn-compatible cart badge refresh (kept as a generic header-counter sync)
    async function refreshCartBadge() {
        try {
            var secRes = await fetch('/?sections=cart-icon-bubble', { headers: { 'Cache-Control': 'no-cache' } });
            if (secRes.ok) {
                var secJson = await secRes.json();
                var html = secJson['cart-icon-bubble'];
                if (html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var newBubble = doc.getElementById('cart-icon-bubble');
                    var mount = document.getElementById('cart-icon-bubble');
                    if (mount && newBubble) { mount.replaceWith(newBubble); return; }
                }
            }
        } catch (_) {}

        var count = 0;
        try {
            var cartRes = await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } });
            if (!cartRes.ok) return;
            var cart = await cartRes.json();
            count = Number(cart.item_count) || 0;
        } catch (_) {}

        var bubbleRoot = document.getElementById('cart-icon-bubble');
        if (bubbleRoot) {
            var bubble = bubbleRoot.querySelector('.cart-count-bubble');
            if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
                bubbleRoot.appendChild(bubble);
            }
            var visibleSpan = bubble.querySelector('span[aria-hidden="true"]') || document.createElement('span');
            visibleSpan.setAttribute('aria-hidden', 'true');
            visibleSpan.textContent = String(count);
            if (!visibleSpan.parentElement) bubble.appendChild(visibleSpan);

            var srSpan = bubble.querySelector('.visually-hidden') || document.createElement('span');
            srSpan.className = 'visually-hidden';
            srSpan.textContent = count + ' item' + (count === 1 ? '' : 's');
            if (!srSpan.parentElement) bubble.appendChild(srSpan);

            bubble.classList.toggle('hidden', count === 0);
        }

        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.setAttribute('data-cart-count', String(count));
        });
        document.querySelectorAll('.cart-count-bubble:not(#cart-icon-bubble .cart-count-bubble), .header__cart-count, .cart-link__bubble')
            .forEach(function (el) {
                if (!el.querySelector('[aria-hidden]')) el.textContent = String(count);
                el.classList.toggle('hidden', count === 0);
                if (el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', String(count === 0));
            });
    }

    function detectCartType() {
        if (document.querySelector('cart-drawer')) return 'drawer';
        if (document.querySelector('cart-notification')) return 'notification';
        return 'page';
    }

    // --- media helpers to reduce latency ---
    function primeSlideMedia(slide) {
        if (!slide) return;
        const vid = slide.querySelector('video');
        const ifr = slide.querySelector('iframe');

        if (vid) {
            // Only switch to metadata preload — do NOT call load() if already initialized
            if (vid.preload === 'none') vid.preload = 'metadata';
            // Call load() only once, before the first use
            if (vid.readyState === 0 && !vid.dataset.csvLoaded) {
            try { vid.load(); } catch(_) {}
            vid.dataset.csvLoaded = '1';
            }
        }
        if (ifr && ifr.getAttribute('loading') === 'lazy') {
            // Let it start loading now
            ifr.removeAttribute('loading');
        }
    }

    function safePlay(vid) {
        if (!vid) return Promise.resolve();
        // If it's already playing, don’t reissue play()
        if (!vid.paused && !vid.ended) return Promise.resolve();

        try {
            const p = vid.play();
            return (p && typeof p.then === 'function') ? p.catch(err => {
            if (err && err.name === 'AbortError') return;            // harmless race
            if (err && err.name === 'NotAllowedError') {             // autoplay policy
                vid.muted = true;
                return vid.play().catch(() => {});
            }
            // Log other errors only if you really need to debug
            }) : Promise.resolve();
        } catch (err) {
            // Synchronous edge cases
            return Promise.resolve();
        }
        }

        function safePause(vid) {
        if (!vid) return;
        if (!vid.paused) {
            try { vid.pause(); } catch(_) {}
        }
    }

    function playMediaFast(media, unmuted) {
        if (!media) return;
        if (media.tagName === 'VIDEO') {
            media.muted = !unmuted;
            return safePlay(media);
        }
        if (media.tagName === 'IFRAME') {
            var provider = media.dataset.provider;
            var tries = 0;
            (function tick(){
                if (!media.contentWindow) { if (++tries > 45) return; return setTimeout(tick, 33); }
                if (provider === 'youtube') {
                    sendYouTube(media, unmuted ? 'unMute' : 'mute');
                    sendYouTube(media, 'playVideo');
                } else if (provider === 'vimeo') {
                    media.contentWindow && media.contentWindow.postMessage({ method:'setVolume', value: unmuted ? 1 : 0 }, VIMEO_ORIGIN);
                    media.contentWindow && media.contentWindow.postMessage({ method:'play' }, VIMEO_ORIGIN);
                }
            })();
        }
    }

    function pauseMedia(media) {
        if (!media) return;
        if (media.tagName === 'VIDEO') {
            try { media.pause(); } catch(_) {}
            media.muted = true;
            return;
        }
        if (media.tagName === 'IFRAME') {
            var p = media.dataset.provider;
            if (p === 'youtube') { sendYouTube(media, 'pauseVideo'); sendYouTube(media, 'mute'); }
            else if (p === 'vimeo') {
                media.contentWindow && media.contentWindow.postMessage({ method:'pause' }, VIMEO_ORIGIN);
                media.contentWindow && media.contentWindow.postMessage({ method:'setVolume', value: 0 }, VIMEO_ORIGIN);
            }
        }
    }

    // ---------- Loop-on-active: support multiple YT iframes simultaneously ----------
    var YTLoopWindows = new Set();

    function setNativeLoopForSlide(slide, enable) {
        var v = slide && slide.querySelector('video');
        if (!v) return;
        v.loop = !!enable;
        if (enable) {
            if (!v.__csvOnEnded) {
                v.__csvOnEnded = function () {
                    try { v.currentTime = 0; v.play().catch(function(){}); } catch (_) {}
                };
            }
            v.removeEventListener('ended', v.__csvOnEnded);
            v.addEventListener('ended', v.__csvOnEnded);
        } else {
            if (v.__csvOnEnded) v.removeEventListener('ended', v.__csvOnEnded);
        }
    }

    function enableYouTubeLoopForIframe(iframe) {
        if (!iframe || !iframe.contentWindow) return;
        try {
            // Track this window for loop restarts
            YTLoopWindows.add(iframe.contentWindow);
            iframe.contentWindow.postMessage(JSON.stringify({ event:'listening', id:'csv-'+Math.random().toString(36).slice(2) }), YT_ORIGIN);
            iframe.contentWindow.postMessage(JSON.stringify({ event:'command', func:'addEventListener', args:['onStateChange'] }), YT_ORIGIN);
        } catch (_) {}
    }

    if (!window.__csvYTLoopListenerAttached) {
        window.__csvYTLoopListenerAttached = true;
        window.addEventListener('message', function (e) {
            if (e.origin !== YT_ORIGIN) return;
            try {
                var data = e.data;
                if (typeof data === 'string') {
                    try { data = JSON.parse(data); } catch (_) { data = null; }
                }

                // Poster fade sync for YouTube via onStateChange
                if (data && data.event === 'onStateChange') {
                    var slide = window.__csvIframeWinToSlide && window.__csvIframeWinToSlide.get(e.source);
                    if (typeof data.info === 'number' && slide) {
                        // 1 = playing, 2 = paused, 0 = ended
                        if (data.info === 1) slide.classList.add('csv-playing');
                        if (data.info === 2 || data.info === 0) slide.classList.remove('csv-playing');
                    }
                    // Loop handling
                    if (data.info === 0 /* ended */ && e.source && YTLoopWindows.has(e.source)) {
                        e.source.postMessage(JSON.stringify({ event:'command', func:'seekTo', args:[0, true] }), YT_ORIGIN);
                        e.source.postMessage(JSON.stringify({ event:'command', func:'playVideo', args:[] }), YT_ORIGIN);
                    }
                }
            } catch (_) {}
        });
    }

    // ---------- Fullscreen helpers ----------
    function csvIsFullscreen() {
        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    }
    function csvExitFullscreen() {
        const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
        if (exit) return exit.call(document);
    }
    async function csvEnterFullscreen(targetEl) {
        if (targetEl && targetEl.tagName === 'VIDEO') {
            const v = targetEl;
            try {
                if (v.requestFullscreen) return await v.requestFullscreen();
                if (v.webkitEnterFullscreen) return v.webkitEnterFullscreen(); // iOS
                if (v.webkitRequestFullscreen) return v.webkitRequestFullscreen();
            } catch (_) { /* fall through */ }
        }
        const el = targetEl || document.documentElement;
        const req = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
        if (!req) throw new Error('Fullscreen API not available');
        return req.call(el);
    }

    function csvInitFullscreenButtons(carousel, embla) {
        function csvCloseFauxFS() {
            document.querySelectorAll('.csv-faux-fs').forEach(function (s) {
                s.classList.remove('csv-faux-fs', 'csv-fs-open', 'is-fullscreen');
            });
            document.documentElement.classList.remove('csv-lock-scroll');
        }
        carousel.querySelectorAll('.embla__slide.csv-slide').forEach(function (slide) {
            const btn = slide.querySelector('.csv-fs-btn');
            if (!btn || btn.dataset.fsInit === '1') return;
            btn.dataset.fsInit = '1';

            btn.addEventListener('click', async function (e) {
                e.stopPropagation();
                if (csvIsFullscreen()) { try { await csvExitFullscreen(); } catch (_) {} return; }
                if (slide.classList.contains('csv-faux-fs')) { csvCloseFauxFS(); return; }
                try {
                    await csvEnterFullscreen(slide);
                    slide.classList.add('is-fullscreen', 'csv-fs-open');
                    btn.setAttribute('aria-pressed', 'true');
                    btn.setAttribute('aria-label', 'Exit fullscreen');
                } catch (err) {
                    slide.classList.add('csv-faux-fs', 'csv-fs-open');
                    document.documentElement.classList.add('csv-lock-scroll');
                    btn.setAttribute('aria-pressed', 'true');
                    btn.setAttribute('aria-label', 'Exit fullscreen');
                }
            });
        });
        if (!window.__csvGlobalDocListeners.fullscreen) {
            ['fullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange'].forEach(function (evt) {
                document.addEventListener(evt, function () {
                    var full = csvIsFullscreen();
                    document.querySelectorAll('.embla__slide.csv-slide').forEach(function (s) {
                        var b = s.querySelector('.csv-fs-btn');
                        if (!b) return;
                        s.classList.toggle('csv-fs-open', full);
                        if (full) {
                            s.classList.add('is-fullscreen');
                            b.setAttribute('aria-pressed', 'true');
                            b.setAttribute('aria-label', 'Exit fullscreen');
                        } else {
                            s.classList.remove('is-fullscreen');
                            b.setAttribute('aria-pressed', 'false');
                            b.setAttribute('aria-label', 'Enter fullscreen');
                        }
                    });
                });
            });
            window.__csvGlobalDocListeners.fullscreen = true;
        }
        if (!window.__csvGlobalDocListeners.escape) {
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    document.querySelectorAll('.csv-faux-fs').forEach(function (s) {
                        s.classList.remove('csv-faux-fs', 'csv-fs-open', 'is-fullscreen');
                    });
                    document.documentElement.classList.remove('csv-lock-scroll');
                }
            });
            window.__csvGlobalDocListeners.escape = true;
        }
    }

    function csvSizedImage(url, size = '200x') {
        if (!url) return '';
        // Normalize protocol
        if (url.startsWith('//')) url = 'https:' + url;
        try {
            const u = new URL(url, window.location.origin);
            // Insert _{size} before the file extension, keep querystring
            const path = u.pathname; // e.g. /s/files/.../image.jpg
            const idx  = path.lastIndexOf('.');
            if (idx > -1) {
            u.pathname = path.slice(0, idx) + '_' + size + path.slice(idx);
            return u.toString();
            }
            // No extension? return original
            return url;
        } catch {
            // Fallback regex (keeps query param if present)
            return url.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, `_${size}$1$2`);
        }
        }

    // Cache products to avoid refetches
    const __csvProductCache = new Map();

    async function fetchProductByHandle(handle){
    if (__csvProductCache.has(handle)) return __csvProductCache.get(handle);
    const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Cache-Control': 'no-cache' } });
    if (!res.ok) throw new Error('product fetch failed: ' + handle);
    const p = await res.json();
    __csvProductCache.set(handle, p);
    return p;
    }

    function findVariantByOptions(product, selections){
    // selections array length == product.options.length; values are option strings
    return product.variants.find(v => {
        if (!v.available) return false; // prefer available; fallback handled by caller if needed
        // Shopify returns option1/2/3 on variant
        for (let i = 0; i < product.options.length; i++){
        const key = 'option' + (i+1);
        if ((v[key] || '') != (selections[i] || '')) return false;
        }
        return true;
    });
    }

    // Build (or get) singleton modal in <body>
    function ensureVariantModal(){
    let wrap = document.getElementById('csv-variant-modal');
    if (wrap) return wrap;
    const backdrop = document.createElement('div');
    backdrop.className = 'csv-variant-modal-backdrop';
    backdrop.id = 'csv-variant-modal';
    backdrop.innerHTML = `
        <div class="csv-variant-modal" role="dialog" aria-modal="true" aria-labelledby="csv-variant-ttl">
        <div class="csv-variant-modal__hdr">
            <h3 class="csv-variant-modal__ttl" id="csv-variant-ttl">Choose options</h3>
            
        </div>
        <div class="csv-variant-modal__body"></div>
        <div class="csv-variant-modal__ftr">
            <button class="csv-btn csv-btn--ghost" data-action="cancel">Cancel</button>
            <button class="csv-btn csv-btn--pri" data-action="confirm">Add to cart</button>
        </div>
        </div>`;
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', (e) => {
        if (e.target === backdrop || e.target.closest('[data-action="close"],[data-action="cancel"]')) closeVariantModal();
    });
    return backdrop;
    }
    function openVariantModal(){ ensureVariantModal().setAttribute('open',''); }
    function closeVariantModal(){ const el = ensureVariantModal(); el.removeAttribute('open'); el.querySelector('.csv-variant-modal__body').innerHTML=''; }

    // Render rows for one or more products with variant selectors.
    // inputProducts: array of { product, qty: number, preselectId?: number }
    // returns Promise that resolves with array of { variantId, quantity } or null if cancelled
    function chooseVariantsForProducts(inputProducts){
    return new Promise((resolve) => {
        const backdrop = ensureVariantModal();
        const body = backdrop.querySelector('.csv-variant-modal__body');
        body.innerHTML = '';

        const rows = [];

        inputProducts.forEach(({ product, qty = 1, preselectId }) => {
        // initial selections = from preselect variant or first available
        let initialVar = product.variants.find(v => v.id === preselectId) ||
                        product.variants.find(v => v.available) ||
                        product.variants[0];

        const selections = [];
        for (let i = 0; i < product.options.length; i++){
            const optName = product.options[i];
            const values = Array.from(new Set(product.variants.map(v => v['option' + (i+1)]))).filter(Boolean);
            selections[i] = initialVar ? initialVar['option' + (i+1)] : values[0];

            // row DOM
        }
        const row = document.createElement('div');
        row.className = 'csv-variant-modal__row';
        const initialVariant =
        product.variants.find(v => v.id === preselectId) ||
        product.variants.find(v => v.available) ||
        product.variants[0];

        const baseImg =
        (initialVariant && initialVariant.featured_image && initialVariant.featured_image.src) ||
        (product.featured_image && product.featured_image) ||
        (product.images && product.images[0]) || '';

        const imgSrc = csvSizedImage(baseImg, '200x');

        row.innerHTML = `
        <img class="csv-variant-modal__img" src="${imgSrc}" alt="">
        <div>
            <p class="csv-variant-modal__name">${product.title}</p>
            <div class="csv-variant-modal__opts"></div>
        </div>
        <div class="csv-variant-modal__qty">
            <label style="font-size:.85rem;opacity:.7;margin-right:6px">Qty</label>
            <input type="number" min="1" step="1" value="${qty}" style="width:64px;padding:6px 8px;border:1px solid #ddd;border-radius:8px">
        </div>
        `;
        const optsWrap = row.querySelector('.csv-variant-modal__opts');

        // Build selects for each option, cascading to valid combinations
        function rebuildSelects(){
            optsWrap.innerHTML = '';
            for (let i = 0; i < product.options.length; i++){
            const values = Array.from(new Set(
                product.variants
                .filter(v => v.available || !product.variants.some(x => x.available)) // show all if none available
                .filter(v => {
                    // respect prior selections for preceding options
                    for (let j = 0; j < i; j++){
                    if (selections[j] && v['option'+(j+1)] !== selections[j]) return false;
                    }
                    return true;
                })
                .map(v => v['option' + (i+1)])
            )).filter(Boolean);

            if (!values.length) continue;

            const sel = document.createElement('select');
            sel.setAttribute('aria-label', product.options[i]);
            values.forEach(val => {
                const opt = document.createElement('option');
                opt.value = val; opt.textContent = val;
                if (val === selections[i]) opt.selected = true;
                sel.appendChild(opt);
            });
            sel.addEventListener('change', () => {
                selections[i] = sel.value;
                // when a selection changes, reset following selections to first available combination
                for (let k = i+1; k < product.options.length; k++){
                selections[k] = null;
                }
                const nextVar =
                findVariantByOptions(product, selections) ||
                product.variants.find(v => {
                    // first available that matches chosen prefixes
                    for (let j = 0; j < product.options.length; j++) {
                    if (selections[j] && v['option' + (j+1)] !== selections[j]) return false;
                    }
                    return v.available;
                }) ||
                product.variants[0];

                // Normalize selections from the chosen variant
                for (let k = 0; k < product.options.length; k++) {
                selections[k] = nextVar['option' + (k+1)];
                }

                // ⬇️ NEW: update preview image for this row
                const preview = row.querySelector('.csv-variant-modal__img');
                const vImg = nextVar && nextVar.featured_image && nextVar.featured_image.src;
                const pImg = (product.featured_image && product.featured_image) || (product.images && product.images[0]) || '';
                preview.src = csvSizedImage(vImg || pImg, '400x');

                rebuildSelects();
            });
            optsWrap.appendChild(sel);
            }
        }
        rebuildSelects();

        body.appendChild(row);
        rows.push({ product, row, getSelection(){
            const qtyEl = row.querySelector('input[type="number"]');
            const q = Math.max(1, parseInt(qtyEl.value || '1',10));
            const v = findVariantByOptions(product, selections) || product.variants[0];
            return { variantId: v.id, quantity: q };
        }});
        });

        function onConfirm(){
        const items = rows.map(r => r.getSelection());
        closeVariantModal();
        resolve(items);
        }
        function onCancel(){ closeVariantModal(); resolve(null); }

        backdrop.querySelector('[data-action="confirm"]').onclick = onConfirm;
        backdrop.querySelector('[data-action="cancel"]').onclick = onCancel;
        openVariantModal();
    });
    }

    // --------------------------- Carousel Initializer ---------------------------

    function initCarousel(carousel, EmblaCarousel) {
        if (!carousel || carousel.dataset.emblaInit === '1') return;
        carousel.dataset.emblaInit = '1';

        preconnectOnce();

        var viewport = carousel.querySelector('.embla__viewport');
        if (!viewport) return;

        var soundOnActive =
            (carousel.getAttribute('data-soundonactive') === 'true') ||
            (carousel.getAttribute('data-unmuteonactive') === 'true');

        var loopOnActive     = (carousel.getAttribute('data-looponactive') === 'true');
        var autoplayOnActive = (carousel.getAttribute('data-autoplay') === 'true');

        var embla = EmblaCarousel(viewport, {
                                        loop: true,
                                        align: 'center',
                                        containScroll: 'trimSnaps',
                                        dragFree: false,
                                        skipSnaps: false
                                    });
        carousel.__embla = embla;

        // Track previous real snap + a 1-frame deferrer
        var prevIndex = embla.selectedScrollSnap();
        function nextFrame(fn){ requestAnimationFrame(() => requestAnimationFrame(fn)); }

        var __csvLastDown = { x: 0, y: 0, t: 0 };
        viewport.addEventListener('pointerdown', function (ev) {
        __csvLastDown.x = ev.clientX || 0;
        __csvLastDown.y = ev.clientY || 0;
        __csvLastDown.t = ev.timeStamp || performance.now();
        }, { passive: true });

        function csvWasDragClick(ev) {
        // distance threshold ~6px helps ignore micro-movements
        var dx = (ev.clientX || 0) - __csvLastDown.x;
        var dy = (ev.clientY || 0) - __csvLastDown.y;
        return Math.hypot(dx, dy) > 6;
        }

        patchYouTubeIframes(carousel);
        csvInitFullscreenButtons(carousel, embla);

        var allSlides = carousel.querySelectorAll('.embla__slide');
        var userMuteState = new WeakMap();
        var allowUnmute = false; // becomes true after a real user gesture
        var userOverride  = new WeakSet();   // sticky per slide

        // --- hook native video events + map iframe windows to slides (for poster) ---
        allSlides.forEach(function (slide) {
            var v = slide.querySelector('video');
            if (v && !v.__csvPosterHooked) {
                v.__csvPosterHooked = true;
                v.addEventListener('playing', function(){ slide.classList.add('csv-playing'); });
                v.addEventListener('pause',   function(){ slide.classList.remove('csv-playing'); });
                v.addEventListener('ended',   function(){ slide.classList.remove('csv-playing'); });
                v.addEventListener('emptied', function(){ slide.classList.remove('csv-playing'); });
            }
            var ifr = slide.querySelector('iframe');
            if (ifr && !ifr.__csvPosterHooked) {
                ifr.__csvPosterHooked = true;
                function mapWin(){ try{ if (ifr.contentWindow) window.__csvIframeWinToSlide.set(ifr.contentWindow, slide); } catch(_){ } }
                mapWin();
                ifr.addEventListener('load', mapWin);
            }
        });

        function markGesture() { allowUnmute = true; }
        ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function (evt) {
            viewport.addEventListener(evt, markGesture, { passive: true });
        });

        var prevBtn = carousel.querySelector('.csv-prev');
        var nextBtn = carousel.querySelector('.csv-next');
        if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); allowUnmute = true; embla.scrollPrev(); });
        if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); allowUnmute = true; embla.scrollNext(); });

        var toggleMute = function (media, shouldMute) {
            if (!media) return;
            if (media.tagName === 'VIDEO') {
                media.muted = shouldMute;
                if (!media.paused) media.play();
                return;
            }
            if (media.tagName === 'IFRAME') {
                var provider = media.dataset.provider;
                if (provider === 'youtube') {
                    sendYouTube(media, shouldMute ? 'mute' : 'unMute');
                } else if (provider === 'vimeo') {
                    media.contentWindow && media.contentWindow.postMessage({ method: 'setVolume', value: shouldMute ? 0 : 1 }, VIMEO_ORIGIN);
                }
            }
        };

        var pauseSlide = function (slide) {
            var media = slide.querySelector('video, iframe');
            if (!media) return;

            pauseMedia(media);
            slide.classList.remove('csv-playing'); // poster back on

            if (loopOnActive) setNativeLoopForSlide(slide, false);
            if (loopOnActive) {
                var ifr = slide.querySelector('iframe[data-provider="youtube"]');
                if (ifr && ifr.contentWindow) YTLoopWindows.delete(ifr.contentWindow);
            }

            // Only force-muted visuals if user hasn't chosen yet
            if (!userOverride.has(slide)) {
                userMuteState.set(slide, true);
                setSoundButtonState(slide.querySelector('.csv-sound-btn'), true);
            }
        };

        var playSlide = function (slide, forceMuted) {
            if (forceMuted === void 0) forceMuted = false;
            var media = slide.querySelector('video, iframe');
            if (!media) return;

            var userMuted = userMuteState.get(slide);
            if (userMuted === false) forceMuted = false;

            playMediaFast(media, !forceMuted);
            slide.classList.add('csv-playing'); // fade poster
        };

        function unmuteAndPlaySlide(slide, embla) {
            if (!slide) return;
            var media = slide.querySelector('video, iframe');
            if (!media) return;

            var currentIndex = embla.selectedScrollSnap();
            var currentSlide = embla.slideNodes()[currentIndex];
            if (currentSlide && currentSlide !== slide) pauseSlide(currentSlide);

            allowUnmute = true;

            var hasOverride = userOverride.has(slide);
            var muted = hasOverride ? !!userMuteState.get(slide) : false;

            userMuteState.set(slide, muted);
            userOverride.add(slide);

            setSoundButtonState(slide.querySelector('.csv-sound-btn'), muted);
            toggleMute(media, muted);
            playSlide(slide, muted);
        }

        function primeNeighbors() {
            var i = embla.selectedScrollSnap();
            var slides = embla.slideNodes();
            primeSlideMedia(slides[i]);
            primeSlideMedia(slides[i - 1]);
            primeSlideMedia(slides[i + 1]);
        }

        function applyLoopStateForActive(activeSlide) {
            if (!loopOnActive || !activeSlide) return;
            embla.slideNodes().forEach(function (s) { setNativeLoopForSlide(s, false); });
            // Clear YT loopers in this carousel; re-add active
            embla.slideNodes().forEach(function (s) {
                var ifr = s.querySelector('iframe[data-provider="youtube"]');
                if (ifr && ifr.contentWindow) YTLoopWindows.delete(ifr.contentWindow);
            });
            setNativeLoopForSlide(activeSlide, true);
            var yt = activeSlide.querySelector('iframe[data-provider="youtube"]');
            if (yt) enableYouTubeLoopForIframe(yt);
        }

        function applyActiveState(initialForceMuted, shouldPlay) {
            if (initialForceMuted === void 0) initialForceMuted = true;
            if (shouldPlay === void 0) shouldPlay = false;

            var realIndex  = embla.selectedScrollSnap();
            var realSlides = embla.slideNodes();
            if (!realSlides || !realSlides.length) return;

            // Detect loop wraps (last→first or first→last)
            var snapCount = embla.scrollSnapList().length;
            var lastSnap  = Math.max(0, snapCount - 1);
            var isWrapNext = (prevIndex === lastSnap && realIndex === 0);
            var isWrapPrev = (prevIndex === 0 && realIndex === lastSnap);
            var isWrap = isWrapNext || isWrapPrev;

            // (A) Only toggle the active class synchronously (cheap)
            realSlides.forEach(function (slideNode, i) {
                slideNode.classList.toggle('csv-active', i === realIndex);
            });

            // (B) Heavy work (pause/mute/poster/loop) in a closure
            var doHeavy = function () {
                // Pause just the previously-active slide (avoid pausing every non-active)
                if (prevIndex !== realIndex && realSlides[prevIndex]) {
                pauseSlide(realSlides[prevIndex]);
                }

                var activeSlide = realSlides[realIndex];
                if (!activeSlide) { prevIndex = realIndex; return; }

                // Preload neighbors after we know the final slide
                primeNeighbors();

                // Determine mute state (respect any user override)
                var media        = activeSlide.querySelector('video, iframe');
                var hasOverride  = userOverride.has(activeSlide);
                var defaultMuted = !(soundOnActive && allowUnmute);
                var muted        = hasOverride ? !!userMuteState.get(activeSlide) : defaultMuted;

                toggleMute(media, muted);
                setSoundButtonState(activeSlide.querySelector('.csv-sound-btn'), muted);

                applyLoopStateForActive(activeSlide);

                if (shouldPlay) {
                playSlide(activeSlide, muted);
                } else {
                pauseSlide(activeSlide); // keep poster up when we shouldn't auto-play
                }

                prevIndex = realIndex; // update after we’ve finished
            };

            // (C) Only when wrapping, defer heavy mutations by one frame
            if (isWrap) {
                // Hide the clone→real jump by freezing the track transition exactly during the wrap
                csvFreezeTrackOnce(carousel, function () {
                    nextFrame(doHeavy); // still defer heavy media mutations one frame
                });
            } else {
                doHeavy();
            }
        }

        // Run once at init: muted (policy-safe) + pause others in this carousel
        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) autoplayOnActive = false;
        var canAutoplayNow = autoplayOnActive && isMostlyInView(carousel);

        // Pause everything when hidden; re-apply state when visible
        function handleVisibility() {
            var embla = carousel.__embla;
            if (!embla) return;
            if (document.hidden) {
                embla.slideNodes().forEach(pauseSlide);
            } else {
                applyActiveState(true, autoplayOnActive && isMostlyInView(carousel));
            }
        }
        document.addEventListener('visibilitychange', handleVisibility, { passive: true });

        // stash for cleanup:
        carousel.__csvOnVisibility = handleVisibility

        applyActiveState(true, canAutoplayNow);

        // --- Autoplay-on-active respected at init, and when entering view ---
        function isMostlyInView(el) {
            var r = el.getBoundingClientRect();
            var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            return r.top < vh * 0.9 && r.bottom > vh * 0.1; // ~10% visible
        }

        var observer = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (!autoplayOnActive) return;
                if (entry.isIntersecting) {
                    applyActiveState(true, true);
                    obs.disconnect();
                }
            });
        }, { threshold: 0.1 });
        observer.observe(carousel);
        carousel.__csvObserver = observer;

        // On selection change (click/tap/drag/arrows): update active, loop, mute state
        embla.on('select', function () {
            // Let Embla finish snapping before we issue media commands
            queueMicrotask(() => requestAnimationFrame(() => {
                applyActiveState(true, autoplayOnActive);
            }));
        });

        // Sound buttons (user override while on this slide)
        allSlides.forEach(function (slide) {
            var soundBtn = slide.querySelector('.csv-sound-btn');
            var media = slide.querySelector('video, iframe');
            if (!soundBtn || !media) return;

            // Initialize visual state without marking override
            setSoundButtonState(soundBtn, true); // start muted

            soundBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                allowUnmute = true;

                var current = userMuteState.has(slide) ? !!userMuteState.get(slide) : true;
                var next = !current;

                userMuteState.set(slide, next);
                userOverride.add(slide);               // sticky from now on
                toggleMute(media, next);
                setSoundButtonState(soundBtn, next);

                // Optional: if user unmuted a paused slide, start playback
                if (!slide.classList.contains('csv-playing') && next === false) {
                    playSlide(slide, false);
                }
            });
        });

        // Click-to-center AND (if enabled) unmute+play immediately
        embla.slideNodes().forEach(function (slideNode, index) {
            slideNode.addEventListener('click', function (e) {
                // Use Embla’s API when available; otherwise fall back to our distance check
                if (embla.clickAllowed && typeof embla.clickAllowed === 'function') {
                    if (!embla.clickAllowed()) return;
                } else {
                    if (csvWasDragClick(e)) return;
                }
                if (e.target.closest('a, button')) return;

                // If already active slide, toggle play/pause
                if (index === embla.selectedScrollSnap()) {
                    var media = slideNode.querySelector('video, iframe');
                    if (!media) return;

                    if (slideNode.classList.contains('csv-playing')) {
                        pauseSlide(slideNode);
                    } else {
                        unmuteAndPlaySlide(slideNode, embla);
                    }
                    return;
                }

                // Otherwise, normal behavior: scroll to that slide
                allowUnmute = true;
                embla.scrollTo(index);
                if (soundOnActive) {
                    unmuteAndPlaySlide(slideNode, embla);
                }
            });
        });

        carousel.querySelectorAll('.csv-click-layer').forEach(function (layer) {
            layer.addEventListener('click', function (e) {
                e.stopPropagation(); e.preventDefault();
                allowUnmute = true;
                var idx = parseInt(layer.dataset.index || '0', 10);
                embla.scrollTo(idx);
                if (soundOnActive) {
                    var targetSlide = embla.slideNodes()[idx] || layer.closest('.embla__slide');
                    if (targetSlide) unmuteAndPlaySlide(targetSlide, embla);
                }
            });
        });

        // ---------------- Products UI (unchanged base) + Prestige cart path ----------------

        // Expand/collapse product drawer (no DOM move)
        carousel.querySelectorAll('.csv-products').forEach(function (wrap) {
            var moreBtn = wrap.querySelector('.csv-more-btn');
            var controls = wrap.querySelector('.csv-products__controls');
            if (!moreBtn) return;

            var slide = wrap.closest('.csv-slide');
            if (!slide || slide.getAttribute('aria-hidden') === 'true' || wrap.dataset.init === '1') return;
            wrap.dataset.init = '1';

            var items = wrap.querySelectorAll('.csv-product-card, .csv-product-badge');
            var itemsCount = items.length;

            if (itemsCount <= 1) {
                wrap.classList.add('csv-expanded');
                wrap.classList.remove('csv-collapsed');
                if (controls) controls.style.display = 'none';
                return;
            }

            wrap.classList.add('csv-collapsed');
            wrap.classList.remove('csv-expanded');

            moreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var expanded = wrap.classList.contains('csv-expanded');
                wrap.classList.toggle('csv-expanded', !expanded);
                wrap.classList.toggle('csv-collapsed', expanded);
                moreBtn.setAttribute('aria-expanded', String(!expanded));
                moreBtn.setAttribute('aria-label', expanded ? 'Show more products' : 'Hide products');
            });
        });

        // Add All button (keeps cart bubble refresh)
        carousel.querySelectorAll('.csv-products .csv-add-all').forEach(function (btn) {
            if (btn.dataset.init === '1') return;
            btn.dataset.init = '1';

            btn.addEventListener('click', async function (e) {
                e.preventDefault();

                // 🔽 NEW: leave fullscreen (native + faux) before any UI opens
                try { if (csvIsFullscreen()) await csvExitFullscreen(); } catch(_) {}
                document.querySelectorAll('.csv-faux-fs').forEach(s => s.classList.remove('csv-faux-fs','csv-fs-open','is-fullscreen'));
                document.documentElement.classList.remove('csv-lock-scroll');

                const wrap = btn.closest('.csv-products');
                if (!wrap) return;

                const slide = wrap.closest('.embla__slide');
                if (slide && (slide.getAttribute('aria-hidden') === 'true' || slide.hasAttribute('data-embla-clone'))) return;

                let handles = (wrap.dataset.productHandles || '')
                .split(',').map(h => h.trim()).filter(Boolean);

                if (!handles.length) {
                handles = Array.from(wrap.querySelectorAll('.csv-product-card, .csv-product-badge'))
                    .map(card => card.dataset.productHandle).filter(Boolean);
                }
                if (!handles.length) return;

                btn.disabled = true;
                btn.classList.add('csv-loading');
                btn.setAttribute('aria-busy','true');
                btn.setAttribute('aria-disabled','true');
                btn.setAttribute('data-prev-label', btn.getAttribute('aria-label') || '');
                btn.setAttribute('aria-label', 'Adding product…');

                try {
                // Fetch all products
                const products = await Promise.all(handles.map(fetchProductByHandle));

                // Split into single-variant and multi-variant
                const singles = [];
                const multis  = [];
                products.forEach(p => {
                    const availableVariants = p.variants.filter(v => v.available);
                    if (p.variants.length <= 1 || availableVariants.length <= 1) {
                    const v = availableVariants[0] || p.variants[0];
                    singles.push({ id: v.id, quantity: 1 });
                    } else {
                    multis.push({ product: p, qty: 1 });
                    }
                });

                let chosen = [];
                if (multis.length){
                    const picked = await chooseVariantsForProducts(multis);
                    if (picked === null) throw new Error('User cancelled variant selection');
                    chosen = picked;
                }

                const items = singles.concat(chosen);

                // Batch add in one request if possible
                if (items.length === 1) {
                    await fetch('/cart/add.js', {
                    method:'POST', headers:{'Content-Type':'application/json'},
                    body: JSON.stringify({ id: items[0].id || items[0].variantId, quantity: items[0].quantity || 1 })
                    });
                } else if (items.length > 1) {
                    await fetch('/cart/add.js', {
                    method:'POST', headers:{'Content-Type':'application/json'},
                    body: JSON.stringify({
                        items: items.map(x => ({
                        id: x.id || x.variantId,
                        quantity: x.quantity || 1
                        }))
                    })
                    });
                }

                // Prestige drawer path first
                if (isPrestige()) {
                    await openPrestigeMiniCart();
                    await refreshCartBadge();
                    btn.classList.add('csv-added');
                    setTimeout(() => btn.classList.remove('csv-added'), 1500);
                    return;
                }

                // Non-Prestige
                const cartType = detectCartType();
                if (cartType === 'drawer') {
                    const cartDrawer = document.querySelector('cart-drawer');
                    const drawerRes = await fetch('/?sections=cart-drawer', { headers:{'Cache-Control':'no-cache'}});
                    const sectionsHTML = await drawerRes.json();
                    const html = sectionsHTML['cart-drawer'];
                    if (cartDrawer && html) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newDrawer = doc.querySelector('cart-drawer');
                    if (newDrawer) { cartDrawer.replaceWith(newDrawer); newDrawer.open && newDrawer.open(); }
                    }
                } else if (cartType === 'notification') {
                    document.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));
                } else {
                    window.location.href = '/cart'; return;
                }

                await refreshCartBadge();
                btn.classList.add('csv-added');
                setTimeout(() => btn.classList.remove('csv-added'), 1500);

                } catch (err) {
                console.error('[CSV] Add all failed:', err);
                } finally {
                btn.disabled = false;
                btn.classList.remove('csv-loading');
                btn.removeAttribute('aria-busy');
                btn.removeAttribute('aria-disabled');
                const prev = btn.getAttribute('data-prev-label');
                btn.setAttribute('aria-label', prev || 'Add all products');
                btn.removeAttribute('data-prev-label');
                }
            });
            });

        // Single-product add (+) (keeps cart bubble refresh)
        carousel.querySelectorAll('.csv-prod-action').forEach(function (btn) {
            if (btn.dataset.init === '1') return;
            btn.dataset.init = '1';

            btn.addEventListener('click', async function (e) {
                e.preventDefault();
                e.stopPropagation();

                // 🔽 NEW: leave fullscreen (native + faux) before any UI opens
                try { if (csvIsFullscreen()) await csvExitFullscreen(); } catch(_) {}
                document.querySelectorAll('.csv-faux-fs').forEach(s => s.classList.remove('csv-faux-fs','csv-fs-open','is-fullscreen'));
                document.documentElement.classList.remove('csv-lock-scroll');

                var container = btn.closest('.csv-product-card, .csv-product-badge');
                var handle = btn.dataset.productHandle || (container && container.dataset && container.dataset.productHandle);
                if (!handle) { console.warn('[CSV] Missing product handle on + button'); return; }

                btn.disabled = true;
                btn.classList.add('csv-loading');

                btn.setAttribute('aria-busy', 'true');
                btn.setAttribute('aria-disabled', 'true');
                btn.setAttribute('data-prev-label', btn.getAttribute('aria-label') || '');
                btn.setAttribute('aria-label', 'Adding product…');

                try {
                    var res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
                    if (!res.ok) throw new Error('product fetch failed');
                    var product = await res.json();
                    var hasMultipleVariants = product.variants.length > 1;

                    if (hasMultipleVariants) {
                        const quickAddBtn = (container && container.querySelector('[data-open-quick-add]')) ||
                            document.querySelector('.csv-product-card[data-product-handle="' + handle + '"] [data-open-quick-add], .csv-product-badge[data-product-handle="' + handle + '"] [data-open-quick-add]');

                        if (quickAddBtn) {
                            quickAddBtn.click();
                            btn.disabled = false;
                            btn.classList.remove('csv-loading');
                            return;
                        }

                        // Fallback: our lightweight variant picker (no page leave)
                        const picked = await chooseVariantsForProducts([{ product, qty: 1 }]);
                        if (picked && picked[0]) {
                            await fetch('/cart/add.js', {
                            method:'POST', headers:{'Content-Type':'application/json'},
                            body: JSON.stringify({ id: picked[0].variantId, quantity: picked[0].quantity })
                            });

                            if (isPrestige()) {
                            await openPrestigeMiniCart();
                            await refreshCartBadge();
                            btn.classList.add('csv-added');
                            setTimeout(() => btn.classList.remove('csv-added'), 1500);
                            } else {
                            const cartType = detectCartType();
                            if (cartType === 'drawer') {
                                const cartDrawer = document.querySelector('cart-drawer');
                                const drawerRes = await fetch('/?sections=cart-drawer', { headers:{'Cache-Control':'no-cache'}});
                                const sectionsHTML = await drawerRes.json();
                                const html = sectionsHTML['cart-drawer'];
                                if (cartDrawer && html) {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(html, 'text/html');
                                const newDrawer = doc.querySelector('cart-drawer');
                                if (newDrawer) { cartDrawer.replaceWith(newDrawer); newDrawer.open && newDrawer.open(); }
                                }
                            } else if (cartType === 'notification') {
                                document.dispatchEvent(new CustomEvent('product:added', { bubbles:true }));
                            } else {
                                window.location.href = '/cart'; return;
                            }
                            await refreshCartBadge();
                            }

                            btn.disabled = false;
                            btn.classList.remove('csv-loading');
                            return;
                        }

                        // User cancelled modal
                        btn.disabled = false;
                        btn.classList.remove('csv-loading');
                        return;
                        }

                    var variantId = product.variants[0].id;
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: variantId, quantity: 1 })
                    });

                    // --- Prestige path (runs first if detected) ---
                    if (isPrestige()) {
                        await openPrestigeMiniCart();
                        await refreshCartBadge();
                        btn.classList.add('csv-added');
                        setTimeout(function () { btn.classList.remove('csv-added'); }, 1500);
                        return; // stop here; skip Dawn/cart-notification/page
                    }

                    // --- Non-Prestige (Dawn/others) ---
                    var cartType = (function () {
                        if (document.querySelector('cart-drawer')) return 'drawer';
                        if (document.querySelector('cart-notification')) return 'notification';
                        return 'page';
                    })();

                    if (cartType === 'drawer') {
                        var cartDrawer = document.querySelector('cart-drawer');
                        var drawerRes = await fetch('/?sections=cart-drawer', { headers: { 'Cache-Control': 'no-cache' } });
                        var sectionsHTML = await drawerRes.json();
                        var html = sectionsHTML['cart-drawer'];
                        if (cartDrawer && html) {
                            var parser = new DOMParser();
                            var doc = parser.parseFromString(html, 'text/html');
                            var newDrawer = doc.querySelector('cart-drawer');
                            if (newDrawer) { cartDrawer.replaceWith(newDrawer); newDrawer.open && newDrawer.open(); }
                        }
                    } else if (cartType === 'notification') {
                        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));
                    } else {
                        window.location.href = '/cart';
                        return;
                    }

                    await refreshCartBadge();
                    btn.classList.add('csv-added');
                    setTimeout(function () { btn.classList.remove('csv-added'); }, 1500);

                } catch (err) {
                    console.error('Error adding to cart:', err);
                } finally {
                    btn.disabled = false;
                    btn.classList.remove('csv-loading');

                    btn.removeAttribute('aria-busy');
                    btn.removeAttribute('aria-disabled');
                    var prev = btn.getAttribute('data-prev-label');
                    btn.setAttribute('aria-label', prev || 'Add all products');
                    btn.removeAttribute('data-prev-label');
                }
            });
        });
    }

    function initAll(EmblaCarousel) {
        document.querySelectorAll('.csv-carousel').forEach(function (carousel) {
            initCarousel(carousel, EmblaCarousel);
        });
    }

    // ------------------------------- Boot & Editor -------------------------------

    onReady(function () {
        getEmbla().then(initAll).catch(function (e) {
            console.error('[CSV] Embla failed to load:', e);
        });
    });

    document.addEventListener('shopify:section:load', function (e) {
        getEmbla().then(function (Embla) {
            e.target.querySelectorAll('.csv-carousel').forEach(function (carousel) {
                initCarousel(carousel, Embla);
            });
        }).catch(function (e) {
            console.error('[CSV] Embla failed to load on section:load:', e);
        });
    });

    document.addEventListener('shopify:section:unload', function (e) {
        e.target.querySelectorAll('.csv-carousel').forEach(function (carousel) {
            try {
                if (carousel.__csvObserver) { carousel.__csvObserver.disconnect(); delete carousel.__csvObserver; }
                if (carousel.__csvOnVisibility) { document.removeEventListener('visibilitychange', carousel.__csvOnVisibility); delete carousel.__csvOnVisibility; }
                if (carousel.__csvOnResize) { window.removeEventListener('resize', carousel.__csvOnResize); delete carousel.__csvOnResize; }
                if (carousel.__embla) { carousel.__embla.destroy(); delete carousel.__embla; }
            } catch (_) {}

            // Clean any YT loop tracking associated with iframes in this carousel
            carousel.querySelectorAll('iframe[data-provider="youtube"]').forEach(function (ifr) {
                if (ifr.contentWindow) { YTLoopWindows.delete(ifr.contentWindow); }
            });

            carousel.removeAttribute('data-embla-init');
        });
    });

})();
